import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import CollegeFairDetailsComponent from './college-fair-details';
import { SimpleLoadingComponent } from '../../utils/apollo';

const query = gql`
  query repVisitsDayDetails($id: ID!) {
    node(id: $id) {
      id
      ... on CollegeFair {
        name
        date
        rsvpDeadline
        startTime
        endTime
        cost
        maxColleges
        numberOfExpectedStudents
        webInstructions
        autoConfirmRequests
        emailInstructions
        status
        currentColleges
        highSchool {
          id
          name
          repVisitsAccount {
            id
            collegeFairsPrimaryContact {
              id
              name
              field_job_position
              field_contact_work
              field_profile_picture_file_url
            }
            collegeFairsPrimaryContactPhone
          }
        }
      }
    }
  }
`;

const graphqlData = graphql(query, {
  options: ({ id }) => ({
    variables: {
      id,
    },
    fetchPolicy: 'cache-and-network',
  }),
});
export default SimpleLoadingComponent(graphqlData)(CollegeFairDetailsComponent);
